import { badgePortalTokens } from "../../../../Badge/tokens/Badge.portal";
import { buttonPortalTokens } from "../../../../Button/tokens/Button.portal";
import { checkboxPortalTokens } from "../../../../Checkbox/components/Checkbox/tokens/Checkbox.portal";
import { formPortalTokens } from "../../../../Form/components/tokens/Form.portal";
import { linkPortalTokens } from "../../../../Link/tokens/Link.portal";
import { iconPortalTokens } from "../../../../icons/Icon/tokens/Icon.portal";
import { checkboxButtonPortalTokens } from "../../../../Checkbox/components/CheckboxButton/tokens/CheckboxButton.portal";
import { checkboxSwitchPortalTokens } from "../../../../Checkbox/components/CheckboxSwitch/tokens/CheckboxSwitch.portal";
import { spinnerPortalTokens } from "../../../../Spinner/tokens/Spinner.portal";
import { tablePortalTokens } from "../../../../Table/tokens/Table.portal";
import { tabsPortalTokens } from "../../../../Tabs/tokens/Tabs.portal";
import { tooltipPortalTokens } from "../../../../Tooltip/tokens/Tooltip.portal";
import { inputPortalTokens } from "../../../../Input/tokens/Input.portal";
import { textareaPortalTokens } from "../../../../Textarea/tokens/Textarea.portal";
import { selectPortalTokens } from "../../../../Select/tokens/Select.portal";
import { paragraphPortalTokens } from "../../../../Paragraph/tokens/Paragraph.portal";
import { popupPortalTokens } from "../../../../Popup/tokens/Popup.portal";
import { popoverPortalTokens } from "../../../../Popover/tokens/Popover.portal";
import { dropdownPortalTokens } from "../../../../Dropdown/tokens/Dropdown.portal";
import { radioPortalTokens } from "../../../../Radio/components/Radio/tokens/Radio.portal";
import { radioButtonPortalTokens } from "../../../../Radio/components/RadioButton/tokens/RadioButton.portal";
import { listPortalTokens } from "../../../../List/tokens/portal/List.portal";
import { notificationPortalTokens } from "../../../../Notification/tokens/Notification.portal";
import { headerPortalTokens } from "../../../../Header/tokens/Header.portal";
import { paginationPortalTokens } from "../../../../Pagination/tokens/Pagination.portal";
import { pageContainerPortalTokens } from "../../../../PageContainer/tokens/PageContainer.portal";
import { nativeSelectPortalTokens } from "../../../../NativeSelect/tokens/NativeSelect.portal";
import { inputDatePickerPortalTokens } from "../../../../InputDatePicker/tokens/InputDatePicker.portal";
import { datePickerPortalTokens } from "../../../../DatePicker/tokens/DatePicker.portal";
import { progressBarPortalTokens } from "../../../../ProgressBar/tokens/ProgressBar.portal";
import { logoPortalTokens } from "../../../../Logo/tokens/Logo.portal";
import { figurePortalTokens } from "../../../../Figure/tokens/Figure.portal";
import { fileUploaderPortalTokens } from "../../../../FileUploader/tokens/FileUploader.portal";
import { stepperPortalTokens } from "../../../../Stepper/tokens/Stepper.portal";
import { cardSelectorPortalTokens } from "../../../../CardSelector/tokens/CardSelector.portal";
import { inputNumberPortalTokens } from "../../../../InputNumber/tokens/InputNumber.portal";
import { notificationManagerPortalTokens } from "../../../../NotificationManager/tokens/NotificationManager.portal";
import { portalPalette } from "./portal.palette";
import { createPortalColor } from "./portal.color";
import { createPochtaTheme } from "../../createPochtaTheme";
export var createPortalThemeConfig = {
  palette: portalPalette,
  color: createPortalColor,
  colors: null,
  palettes: null,
  font: {
    fontFamily: "Golos, sans-serif",
    defaultSize: "m",
    color: function color(_ref) {
      var _color = _ref.color;
      return _color.text.black.base;
    },
    sizes: {
      xxxl: {
        fontSize: "48px",
        lineHeight: "60px"
      },
      xxl: {
        fontSize: "32px",
        lineHeight: "40px"
      },
      xl: {
        fontSize: "24px",
        lineHeight: "30px"
      },
      l: {
        fontSize: "18px",
        lineHeight: "24px"
      },
      m: {
        fontSize: "16px",
        lineHeight: "20px"
      },
      s: {
        fontSize: "14px",
        lineHeight: "18px"
      },
      xs: {
        fontSize: "12px",
        lineHeight: "16px"
      }
    }
  },
  shadows: {
    level1: function level1(_ref2) {
      var paletteFromTheme = _ref2.palette;
      return "0 1px 2px 2px ".concat(paletteFromTheme.neutralsBlack.rgba10);
    },
    stickyBox: function stickyBox(_ref3) {
      var paletteFromTheme = _ref3.palette;
      return "0 30px 40px ".concat(paletteFromTheme.neutralsBlack.rgba10);
    }
  },
  simpleBreakpoints: {
    xs: 0,
    sm: 768,
    md: 1024,
    lg: 1366,
    xl: 1920
  },
  simpleBreakpointsOrder: ["xs", "sm", "md", "lg", "xl"],
  complexBreakpoints: function complexBreakpoints(_ref4) {
    var up = _ref4.up,
        down = _ref4.down,
        between = _ref4.between;
    return {
      desktop: up("md"),
      notDesktop: down("md"),
      mobile: down("sm"),
      notMobile: up("sm"),
      tablet: between("sm", "md")
    };
  },
  componentsTokens: {
    badge: badgePortalTokens,
    button: buttonPortalTokens,
    checkbox: checkboxPortalTokens,
    checkboxButton: checkboxButtonPortalTokens,
    checkboxSwitch: checkboxSwitchPortalTokens,
    form: formPortalTokens,
    link: linkPortalTokens,
    icon: iconPortalTokens,
    table: tablePortalTokens,
    tabs: tabsPortalTokens,
    tooltip: tooltipPortalTokens,
    spinner: spinnerPortalTokens,
    input: inputPortalTokens,
    textarea: textareaPortalTokens,
    select: selectPortalTokens,
    paragraph: paragraphPortalTokens,
    popup: popupPortalTokens,
    popover: popoverPortalTokens,
    dropdown: dropdownPortalTokens,
    radio: radioPortalTokens,
    radioButton: radioButtonPortalTokens,
    list: listPortalTokens,
    notification: notificationPortalTokens,
    notificationManager: notificationManagerPortalTokens,
    header: headerPortalTokens,
    pagination: paginationPortalTokens,
    pageContainer: pageContainerPortalTokens,
    nativeSelect: nativeSelectPortalTokens,
    datePicker: datePickerPortalTokens,
    inputDatePicker: inputDatePickerPortalTokens,
    progressBar: progressBarPortalTokens,
    logo: logoPortalTokens,
    figure: figurePortalTokens,
    fileUploader: fileUploaderPortalTokens,
    stepper: stepperPortalTokens,
    cardSelector: cardSelectorPortalTokens,
    inputNumber: inputNumberPortalTokens
  },
  zIndex: {
    low: 9,
    medium: 99,
    high: 999,
    higher: 9999,
    highest: 99999
  },
  grid: {
    columns: 12,
    gap: [0, 10]
  }
};
export var portalTheme = createPochtaTheme(createPortalThemeConfig);